// Add your custom JS here.
import { Popover } from './bootstrap'

// Initialize popovers when DOM is ready
document.addEventListener('DOMContentLoaded', function() {
  var popoverTriggerList = Array.from(document.querySelectorAll('[data-bs-toggle="popover"]'))
  var popoverList = popoverTriggerList.map(function (popoverTriggerEl) {
    return new Popover(popoverTriggerEl, {
      container: 'body',
      html: true,
      content: function () {
        return document.getElementById('opening-times-content').innerHTML
      }
    })
  })
});

(function ($) {

  // --- CORE FIX FUNCTION ---
  /**
   * Adjusts the Slick Slider view when centerMode is active on mobile.
   * Forces the first slide (index 0) to start flush left instead of centered.
   * * @param {string} sliderSelector - The jQuery selector for the slider element(s).
   * @param {number} mobileBreakpoint - The breakpoint (in pixels) used in Slick's responsive settings.
   */
  function centerModeFixer(sliderSelector, mobileBreakpoint) {
    $(sliderSelector).on('init', function(event, slick){
      // Check if the current screen width is less than the specified breakpoint
      // AND check if the active settings include centerMode.
      // This logic is slightly complex as slick.options is the base, but we rely 
      // on the responsive settings being applied correctly by slick itself.
      
      // A safe check is to use the breakpoint defined in the responsive array.
      if ($(window).width() < mobileBreakpoint) {
          // Use a slight delay to ensure the slider has fully rendered and calculated positions
          setTimeout(function() {
              // Only apply if the current Slick configuration actually has centerMode enabled
              if (slick.options.centerMode) {
                  // Go to the first slide (index 0) without animation (false)
                  slick.slickGoTo(0, false); 
                  // Move to the "previous" slide, which forces the first slide (0) to the left edge
                  slick.slickPrev();
              }
          }, 50); // Small 50ms delay for robustness
      }
    });
  }
  // -------------------------

  $(document).ready(function () {

    // --- Center Mode Fix Application ---
    
    // Apply fix to the triple-slider: Mobile breakpoint 767px or 600px
    centerModeFixer(".triple-slider", 767); 
    
    // Apply fix to the quad-slider: Mobile breakpoint 991px, 767px, or 600px
    centerModeFixer(".quad-slider", 991); 
    
    // Apply fix to the twin-slider / tribe-related-events: Mobile breakpoint 991px, 767px, or 600px
    centerModeFixer(".twin-slider, .tribe-related-events", 991); 
    
    // Apply fix to the film-slider: Mobile breakpoint 600px
    centerModeFixer(".film-slider", 600); 

    // Apply fix to the badge-slider: Mobile breakpoint 600px
    centerModeFixer(".badge-slider", 600); 

    // -----------------------------------

    // Slick slider for featured for single slides
    $(".single-slider").slick({
      infinite: false,
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplaySpeed: 5000,
      autoplay: true,
      speed: 1000,
      arrows: true,
      prevArrow:
        '<div class="arrow prev"><svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 16 16"><path fill="currentColor" d="M.5 8L8 15.5V11h8V5H8V.5z"/></svg></div>',
      nextArrow:
        '<div class="arrow next"><svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 16 16"><path fill="currentColor" d="M15.5 8L8 .5V5H0v6h8v4.5z"/></svg></div>',
      dots: true,
    });

    // Slick Nav Gallery for single slider
    $(".slider-nav > div").click(function () {
      $(".single-slider").slick("slickGoTo", $(this).index());
    });

    // Slick slider shows 3 slides desktop, 2 tablet, 1 mobile
    // For example: used on homepage news
    $(".triple-slider").slick({
      infinite: false,
      slidesToShow: 3,
      slidesToScroll: 3,
      autoplaySpeed: 5000,
      autoplay: true,
      speed: 1000,
      prevArrow:
        '<div class="arrow prev"><svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 16 16"><path fill="currentColor" d="M.5 8L8 15.5V11h8V5H8V.5z"/></svg></div>',
      nextArrow:
        '<div class="arrow next"><svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 16 16"><path fill="currentColor" d="M15.5 8L8 .5V5H0v6h8v4.5z"/></svg></div>',
      arrows: false,
      dots: false,
      focusOnSelect: false,
      responsive: [
        {
          breakpoint: 991,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            centerMode: true,
            centerPadding: "0px",
          },
        },
        {
          breakpoint: 767,
          settings: {
            centerMode: false,
            slidesToShow: 1,
            slidesToScroll: 1,
            centerMode: true,
            centerPadding: "40px",
          },
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            centerMode: true,
            centerPadding: "40px",
          },
        },
      ],
    });

    // Slick slider for 4 slides
    $(".quad-slider").slick({
      infinite: false,
      slidesToShow: 4,
      slidesToScroll: 1,
      // centerMode: true,
      autoplaySpeed: 5000,
      autoplay: true,
      speed: 1000,
      prevArrow:
        '<div class="arrow prev"><svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 16 16"><path fill="currentColor" d="M.5 8L8 15.5V11h8V5H8V.5z"/></svg></div>',
      nextArrow:
        '<div class="arrow next"><svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 16 16"><path fill="currentColor" d="M15.5 8L8 .5V5H0v6h8v4.5z"/></svg></div>',
      arrows: true,
      dots: true,
      focusOnSelect: false,
      responsive: [
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 991,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            centerMode: true,
            centerPadding: "40px",
          },
        },
        {
          breakpoint: 767,
          settings: {
            centerMode: false,
            slidesToShow: 1,
            slidesToScroll: 1,
            centerMode: true,
            centerPadding: "40px",
          },
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            centerMode: true,
            centerPadding: "40px",
          },
        },
      ],
    });

    // Slick slider for 2 slides
    $(".twin-slider, .tribe-related-events").slick({
      infinite: false,
      slidesToShow: 2,
      slidesToScroll: 1,
      // centerMode: true,
      autoplaySpeed: 5000,
      autoplay: true,
      speed: 1000,
      prevArrow:
        '<div class="arrow prev"><svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 16 16"><path fill="currentColor" d="M.5 8L8 15.5V11h8V5H8V.5z"/></svg></div>',
      nextArrow:
        '<div class="arrow next"><svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 16 16"><path fill="currentColor" d="M15.5 8L8 .5V5H0v6h8v4.5z"/></svg></div>',
      arrows: false,
      dots: false,
      focusOnSelect: false,
      responsive: [
        {
          breakpoint: 991,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            centerMode: true,
            centerPadding: "40px",
          },
        },
        {
          breakpoint: 767,
          settings: {
            centerMode: false,
            slidesToShow: 1,
            slidesToScroll: 1,
            centerMode: true,
            centerPadding: "40px",
          },
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            centerMode: true,
            centerPadding: "40px",
          },
        },
      ],
    });

    // Slick slider for films shows 4 slides desktop
    $(".film-slider").slick({
      infinite: false,
      slidesToShow: 4,
      slidesToScroll: 1,
      // centerMode: true,
      autoplaySpeed: 5000,
      autoplay: true,
      speed: 1000,
      arrows: false,
      dots: true,
      focusOnSelect: false,
      responsive: [
        {
          breakpoint: 767,
          settings: {
            centerMode: false,
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            centerMode: true,
          },
        },
      ],
    });

    // Slick slider for badges
    $(".badge-slider").slick({
      infinite: false,
      slidesToShow: 4,
      slidesToScroll: 1,
      autoplaySpeed: 5000,
      autoplay: true,
      speed: 1000,
      dots: false,
      arrows: false,
      focusOnSelect: false,
      responsive: [
        {
          breakpoint: 767,
          settings: {
            centerMode: false,
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            centerMode: true,
          },
        },
      ],
    });
  });

  $("#navbarNavDropdown").on("show.bs.collapse", function () {
    $("body").addClass("noscroll");
  });

  $("#navbarNavDropdown").on("hide.bs.collapse", function () {
    $("body").removeClass("noscroll");
  });

  if ($("#stores-ticker-a").length) {
    // use this if you are using id to check
    $("#stores-ticker-a").grouploop({
      // animation speed
      velocity: 0.5,
      // false = from left to right
      forward: false,
      // enable pause on hover
      pauseOnHover: true,
    });
  }
  if ($("#stores-ticker-b").length) {
    // use this if you are using id to check
    $("#stores-ticker-b").grouploop({
      // animation speed
      velocity: 0.5,
      // false = from left to right
      forward: true,
      // enable pause on hover
      pauseOnHover: true,
    });
  }
  if ($("#list-nav").length) {
    // use this if you are using id to check
    $("#list-nav").listnav({ showCounts: false });
  }

  $(".logo-holder h1").fitText(0.7, {
    minFontSize: "18px",
    maxFontSize: "36px",
  });

  if ($(".card-group .logo-holder").length) {
    $(".card-group .logo-holder").click(function () {
      var link = $(this).data("href");
      window.location.href = link;
    });
  }

  $(".responsive-tabs").responsiveTabs({
    accordionOn: ["xSmall", "small"],
  });

  $(window).resize(function () {
    $(".responsive-tabs").responsiveTabs({
      accordionOn: ["xSmall", "small"],
    });
  });

  $(document).on(
    "click",
    ".responsive-tabs .dropdown-item a",
    function (event) {
      var $this = $(this),
        $siblings = $this.parent().siblings("li");

      $this.addClass("active");

      $siblings.each(function (index, element) {
        $(element).find("a").removeClass("active");
      });
    }
  );

    function enableDragging() {
        jQuery('.image-container').each(function () {
            var $container = jQuery(this);
            var $img = $container.find('img');
            var $zoomInButton = $container.find('.zoom-in');
            var $zoomOutButton = $container.find('.zoom-out');

            var scale = 1;
            var scaleStep = 0.5;
            var zoomOutStep = 0.5;
            var maxScale = 3;
            var minScale = 1;
            var isDragging = false;
            var startX, startY, initialX, initialY;
            var originalLeft = 0;
            var originalTop = 0;

            $zoomInButton.on('click', function () {
                if (scale < maxScale) {
                    scale += scaleStep;
                    $img.css({
                        'transform': 'scale(' + scale + ')',
                        'transform-origin': 'center center'
                    });
                }
            });

            $zoomOutButton.on('click', function () {
                if (scale > minScale) {
                    scale -= zoomOutStep;
                    if (scale < minScale) scale = minScale;
                    $img.css({
                        'transform': 'scale(' + scale + ')',
                        'transform-origin': 'center center'
                    });
                    if (scale === minScale) {
                        $img.css({
                            'left': originalLeft + 'px',
                            'top': originalTop + 'px'
                        });
                    }
                }
            });

            $img.on('mousedown touchstart', function (e) {
                if (scale > minScale) {
                    isDragging = true;
                    startX = e.type === 'touchstart' ? e.originalEvent.touches[0].pageX : e.pageX;
                    startY = e.type === 'touchstart' ? e.originalEvent.touches[0].pageY : e.pageY;
                    initialX = parseFloat($img.css('left')) || 0;
                    initialY = parseFloat($img.css('top')) || 0;
                    $img.css('cursor', 'grabbing');
                    e.preventDefault();
                }
            });

            jQuery(document).on('mousemove touchmove', function (e) {
                if (isDragging) {
                    var currentX = e.type === 'touchmove' ? e.originalEvent.touches[0].pageX : e.pageX;
                    var currentY = e.type === 'touchmove' ? e.originalEvent.touches[0].pageY : e.pageY;
                    var dx = currentX - startX;
                    var dy = currentY - startY;
                    $img.css({
                        left: initialX + dx + 'px',
                        top: initialY + dy + 'px'
                    });
                    e.preventDefault();
                }
            });

            jQuery(document).on('mouseup touchend', function () {
                isDragging = false;
                $img.css('cursor', 'grab');
            });

            $img.css('cursor', 'grab');
            originalLeft = parseFloat($img.css('left')) || 0;
            originalTop = parseFloat($img.css('top')) || 0;
        });
    }

    function disableDragging() {
        jQuery('.image-container').each(function () {
            var $container = jQuery(this);
            var $img = $container.find('img');
            var $zoomInButton = $container.find('.zoom-in');
            var $zoomOutButton = $container.find('.zoom-out');

            $zoomInButton.off('click');
            $zoomOutButton.off('click');
            $img.off('mousedown touchstart');
            jQuery(document).off('mousemove touchmove');
            jQuery(document).off('mouseup touchend');
            $img.css('cursor', '');
        });
    }

    function checkScreenSize() {
        if (window.innerWidth > 992) {
            enableDragging();
        } else {
            disableDragging();
        }
    }

    jQuery(window).on('resize', checkScreenSize);
    checkScreenSize();

})(jQuery);

function handleFirstTab(e) {
  if (e.keyCode === 9) {
    // the "I am a keyboard user" key
    document.body.classList.add("user-is-tabbing");
    window.removeEventListener("keydown", handleFirstTab);
  }
}

window.addEventListener("keydown", handleFirstTab);

// Swiper JS
function swiperJsSlider() {
  var swiper = new Swiper(".block-swiper", {
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
    navigation: {
      nextEl: ".swiper-arrow-next",
      prevEl: ".swiper-arrow-prev",
    },
  });
}
swiperJsSlider();